export default __webpack_public_path__ + "static/NIIT-01d77d6fa01fb39947bc57e92389eb42.png";